$(".is--home-videos-slider").append(`
    <div class="swiper--btns is--videos"><a href="#" class="swiper-button-prev w-inline-block swiper-button-disabled" tabindex="-1" role="button" aria-label="Previous slide" aria-controls="swiper-wrapper-f613da331297fa67" aria-disabled="true"><svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 48 48" fill="none"><path d="M13.2675 22.9892C12.877 23.3797 12.877 24.0129 13.2675 24.4034L19.6315 30.7674C20.022 31.1579 20.6552 31.1579 21.0457 30.7674C21.4362 30.3768 21.4362 29.7437 21.0457 29.3531L15.3889 23.6963L21.0457 18.0394C21.4362 17.6489 21.4362 17.0157 21.0457 16.6252C20.6552 16.2347 20.022 16.2347 19.6315 16.6252L13.2675 22.9892ZM33.4177 22.6963L13.9746 22.6963L13.9746 24.6963L33.4177 24.6963L33.4177 22.6963Z" fill="currentColor"></path><circle cx="24" cy="24" r="23.5" transform="rotate(-180 24 24)" stroke="currentColor"></circle></svg></a><a href="#" class="swiper-button-next w-inline-block" tabindex="0" role="button" aria-label="Next slide" aria-controls="swiper-wrapper-f613da331297fa67" aria-disabled="false"><svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 49 48" fill="none"><path d="M35.3038 25.0108C35.6943 24.6203 35.6943 23.9871 35.3038 23.5966L28.9398 17.2326C28.5493 16.8421 27.9161 16.8421 27.5256 17.2326C27.1351 17.6232 27.1351 18.2563 27.5256 18.6469L33.1824 24.3037L27.5256 29.9606C27.1351 30.3511 27.1351 30.9843 27.5256 31.3748C27.9161 31.7653 28.5493 31.7653 28.9398 31.3748L35.3038 25.0108ZM15.1536 25.3037L34.5967 25.3037L34.5967 23.3037L15.1536 23.3037L15.1536 25.3037Z" fill="currentColor"></path><circle cx="24.5714" cy="24" r="23.5" stroke="currentColor"></circle></svg></a></div>
`);

document.addEventListener("DOMContentLoaded", function () {
  // Select all swiper-slide elements
  const slides = document.querySelectorAll(".swiper-slide");

  slides.forEach((slide) => {
    // Find the video link inside the slide
    const videoLink = slide.querySelector(".video--link");
    if (videoLink) {
      const videoUrl = videoLink.textContent.trim();

      // Find the source element inside the video element in the same slide
      const videoSource = slide.querySelector(".video_element video source");
      if (videoSource) {
        // Set the video URL as the src of the source element
        videoSource.src = videoUrl;

        // Load the video with the new source
        videoSource.closest("video").load();
      }
    }
  });
});

const swiper2 = new Swiper(".is--home-videos-slider", {
  // Optional parameters
  direction: "horizontal",
  slidesPerView: 1,
  spaceBetween: "24rem",
  centeredSlides: true,
  loopAdditionalSlides: 1,
  loop: true,
  initialSlide: 3, // Set the third slide as the initial active slide
  on: {
    slideChange: function () {
      let slides = this.slides;
      slides.forEach((slide) => {
        slide.classList.remove("swiper-slide-active-zoom");
      });
      slides[this.activeIndex].classList.add("swiper-slide-active-zoom");
    },
  },

  // If we need pagination
  pagination: {
    el: ".swiper-pagination",
  },
  breakpoints: {
    // When window width is >= 992px
    992: {
      slidesPerView: 1,
    },
  },
  // Navigation arrows
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },

  // And if we need scrollbar
  scrollbar: {
    el: ".swiper-scrollbar",
  },
});
